// The limits bolane-api enforces on loan amounts (LoanLimits in its shared kernel). The forms check
// them too so staff and distributors see the limit before the API rejects the request. Borgo's loan
// part minimum applies to green loan parts too.
export const LoanLimits = {
  MIN_TOPUP_AMOUNT: 100_000,
  MIN_AMOUNT: 200_000,
  MAX_AMOUNT: 100_000_000,
  MIN_LOAN_PART_AMOUNT: 100_000,
  MIN_GREEN_LOAN_PART_AMOUNT: 100_000,
  MAX_LOAN_PARTS: 50,
} as const

export type LoanLimitSet = {
  MIN_AMOUNT: number
  MAX_AMOUNT: number
  MIN_LOAN_PART_AMOUNT: number
  MIN_GREEN_LOAN_PART_AMOUNT: number
  MAX_LOAN_PARTS: number
}

// Hypoteket's staff lend under Hypoteket's own limits rather than Borgo's: from 200 000 kr up to
// 9 500 000 kr, in at most 10 loan parts of at least 200 000 kr, or 50 000 kr for a green part.
export const HypoteketLoanLimits = {
  MIN_AMOUNT: 200_000,
  MAX_AMOUNT: 9_500_000,
  MIN_LOAN_PART_AMOUNT: 200_000,
  MIN_GREEN_LOAN_PART_AMOUNT: 50_000,
  MAX_LOAN_PARTS: 10,
} as const satisfies LoanLimitSet

/** The loan limits staff of the given organisation lend under. */
export const loanLimitsFor = (organisation: string | null): LoanLimitSet =>
  organisation === 'Hypoteket' ? HypoteketLoanLimits : LoanLimits
